import { render, staticRenderFns } from "./TextInputConfiguration.vue?vue&type=template&id=e8d6cf12&scoped=true&"
import script from "./TextInputConfiguration.vue?vue&type=script&lang=js&"
export * from "./TextInputConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./TextInputConfiguration.vue?vue&type=style&index=0&id=e8d6cf12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d6cf12",
  null
  
)

export default component.exports